import React from "react";
import ReactTooltip from "react-tooltip";

const TourSummaryAddProductForm = ({ handleFieldChange, handleAddProduct, productFields, handleAddProductRecipient }) => {

  const totalResiduePercentages = productFields.recipients.filter(r => r.type === "residue")
    .reduce((total, recipient) => {
      return parseFloat(recipient.split) + total;
    }, 0);

  const totalFixedShares = productFields.recipients.filter(r => r.type === "prior")
    .reduce((total, recipient) => {
      return parseFloat(recipient.split) + total;
    }, 0);

  const residueToSplit = productFields.price - totalFixedShares;

  const blankNamesArray = productFields.recipients.filter(r => r.recipientName === "");
  const blankNames = blankNamesArray.length > 0;

  return (
    <form className="hideFormLtTablet" id="addProductForm" onSubmit={handleAddProduct}>

        <h3 className="form-heading">Add a product</h3>

        <div>
          <label htmlFor="name">Product Name</label>
          <input
            type="text"
            name="name"
            id="name"
            value={productFields.name}
            onChange={handleFieldChange}
          />
        </div>

        <div>
        <label htmlFor="artist">Artist</label>
          <input
            type="text"
            name="artist"
            id="artist"
            value={productFields.artist}
            onChange={handleFieldChange}
          />
        </div>

        <div>
          <label htmlFor="price">Price (£)</label>
          <input
            type="number"
            step="any"
            name="price"
            id="price"
            value={productFields.price}
            onChange={handleFieldChange}
          />
        </div>

        <h4 className="form-heading sub">sales of this product are divided between...</h4>

        <div className="product-recipients-header grid-container">
          <strong>Name <span className="tipTrigger" data-tip data-for="recipientNameTip">?</span></strong>
          <strong>Type of share <span className="tipTrigger" data-tip data-for="recipientShareTip">?</span></strong>
          <strong>Share (% or £)</strong>
          <strong></strong>
        </div>

        <ReactTooltip id="recipientNameTip" multiline={true} type="light">
          The people who are entitled<br />to a share of the sales<br /> of this product
        </ReactTooltip>

        <ReactTooltip id="recipientShareTip" multiline={true} type="light">
          The way that this person's<br /> share is calculated.
        </ReactTooltip>

          {
            productFields.recipients.map((recipient, index) => {
              return (
                <div key={`${recipient}-${index}`} className="product-recipient grid-container">

                  <input
                    type="text"
                    name="recipientName"
                    id={`recipient-${index}-name`}
                    value={recipient.recipientName}
                    onChange={event => handleFieldChange(event, index)}
                  />

                  <select
                    id={`recipient-${index}-type`}
                    name="type"
                    value={recipient.type}
                    onChange={event => handleFieldChange(event, index)}
                  >
                    <option value="prior">Fixed prior share (£)</option>
                    <option value="residue">Percentage of residue (%)</option>
                  </select>

                  <input
                    type="number"
                    step="any"
                    name="split"
                    id={`recipient-${index}-split`}
                    value={recipient.split}
                    onChange={event => handleFieldChange(event, index)}
                  />

                  {
                    residueToSplit > 0 &&
                    totalResiduePercentages < 100 &&
                    totalFixedShares < productFields.price &&
                    index === productFields.recipients.length - 1 &&
                    (
                      <>
                      <button
                        type="button"
                        onClick={handleAddProductRecipient}
                        data-tip
                        data-for="addRecipientTip"
                      >+</button>

                      <ReactTooltip id="addRecipientTip">
                        Add another person
                      </ReactTooltip>
                      </>
                    )
                  }

                </div>
              )
            })
          }

        

        {
          totalResiduePercentages !== 100 && residueToSplit > 0 &&
          (
            <p className="alert">
              The total of all residue percentages must add up to 100. Current total = {totalResiduePercentages}
            </p>
          )
        }

        {
          totalFixedShares > productFields.price &&
          (
            <p className="alert">
              The total of fixed shares can't be greater than the price.
            </p>
          )
        }

        <div>
        <button
          disabled={
            !productFields.name ||
            !productFields.artist ||
            !productFields.price ||
            (totalResiduePercentages !== 100 && residueToSplit > 0) ||
            totalFixedShares > productFields.price ||
            blankNames
          } 
          className="form-button" 
          type="submit"
        >Add product</button>
        
        </div>

      </form>
  )

};

export default TourSummaryAddProductForm;